import { formatStatus } from '../content/formatStatus'
import TryIt from '../components/TryIt'
import VideoPlayer from '../components/VideoPlayer'

export default function ProjectSection({ project }) {
  if (!project) return null

  const buildersParagraphs = project.buildersNote
    ? project.buildersNote.split(/\n\n+/).map((part) => part.trim()).filter(Boolean)
    : []

  return (
    <section
      id={`project-${project.slug}`}
      data-testid={`project-${project.slug}`}
      className="section section--project"
    >
      <h2 data-testid={`project-name-${project.slug}`}>{project.displayName}</h2>
      <p data-testid={`project-status-${project.slug}`} className="project-status">
        {formatStatus(project.status)}
      </p>
      <p data-testid={`project-summary-${project.slug}`}>{project.summary}</p>
      {project.publicLinks?.length > 0 ? (
        <ul data-testid={`project-links-${project.slug}`} className="project-links">
          {project.publicLinks.map((link) => (
            <li key={link.url}>
              <a href={link.url} rel="noopener noreferrer" target="_blank">
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      ) : null}
      {project.tryIt ? (
        <div data-testid={`project-tryit-${project.slug}`} className="project-slot">
          <TryIt project={project} />
        </div>
      ) : null}
      <div data-testid={`project-video-${project.slug}`} className="project-slot">
        {project.video?.availability === 'ready' ? (
          <VideoPlayer
            src={project.video.src}
            slug={project.slug}
            frame={project.video.frame}
            poster={project.video.poster}
          />
        ) : (
          <p data-testid="video-coming-soon">Video coming soon</p>
        )}
      </div>
      {buildersParagraphs.length > 0 || project.archifyPreview ? (
        <aside data-testid={`project-builders-${project.slug}`} className="builders-note">
          <h3>For builders</h3>
          {buildersParagraphs.map((paragraph) => (
            <p key={paragraph.slice(0, 48)}>{paragraph}</p>
          ))}
          {project.archifyPreview ? (
            <div
              className="archify-preview"
              data-testid={`project-archify-${project.slug}`}
            >
              {project.archifySourcePath ? (
                <p className="archify-preview__path">
                  <code>{project.archifySourcePath}</code>
                </p>
              ) : null}
              <div className="archify-preview__viewport">
                <iframe
                  className="archify-preview__frame"
                  title={`${project.displayName} architecture map`}
                  src={`${project.archifyPreview}?embed=1`}
                  loading="lazy"
                />
              </div>
              <p className="archify-preview__open">
                <a href={project.archifyPreview} target="_blank" rel="noopener noreferrer">
                  Open full architecture map →
                </a>
              </p>
            </div>
          ) : null}
        </aside>
      ) : null}
      {project.lastPortfolioUpdate ? (
        <p data-testid={`project-updated-${project.slug}`}>
          Updated {project.lastPortfolioUpdate}
        </p>
      ) : null}
    </section>
  )
}
